import { render, staticRenderFns } from "./materialMarkTip.vue?vue&type=template&id=2af23568&scoped=true&"
import script from "./materialMarkTip.vue?vue&type=script&lang=js&"
export * from "./materialMarkTip.vue?vue&type=script&lang=js&"
import style0 from "./materialMarkTip.vue?vue&type=style&index=0&id=2af23568&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2af23568",
  null
  
)

export default component.exports